import { TEMPLATE, TRANSPROFILE } from "app/shared/services/services-model.type";
import {
  FETCH_LIST_BENE_REQUEST,
  FETCH_LIST_BENE_SUCCESS,
  FETCH_LIST_BENE_FAILURE,
  RESET_LIST_BENE,
  FETCH_ADD_BENE_PROFILE_REQUEST,
  FETCH_ADD_BENE_PROFILE_SUCCESS,
  FETCH_ADD_BENE_PROFILE_FAILURE,
  FETCH_ADD_BENE_TEMPLATE_REQUEST,
  FETCH_ADD_BENE_TEMPLATE_SUCCESS,
  FETCH_ADD_BENE_TEMPLATE_FAILURE,
  SET_BENE_STORE,
} from "./actions.type";
import {
  FetchListBeneRequest,
  FetchListBeneSuccess,
  FetchListBeneFailure,
  FilterBene,
  ResetListBeneStore,
  FetchAddBeneProfileRequest,
  FetchAddBeneProfileSuccess,
  FetchAddBeneProfileFailure,
  FetchAddBeneTemplateRequest,
  FetchAddBeneTemplateSuccess,
  FetchAddBeneTemplateFailure,
  AddBeneProfile,
  SetBeneStore,
  BeneState,
} from "./types";

export const setBeneStore = (payload?: BeneState): SetBeneStore => ({
  type: SET_BENE_STORE,
  payload,
});

export const resetListBene = (): ResetListBeneStore => ({
  type: RESET_LIST_BENE,
});

export const fetchListBeneRequest = (payload?: FilterBene): FetchListBeneRequest => ({
  type: FETCH_LIST_BENE_REQUEST,
  payload,
});

export const fetchListBeneSuccess = (payload?: TRANSPROFILE[]): FetchListBeneSuccess => ({
  type: FETCH_LIST_BENE_SUCCESS,
  payload,
});

export const fetchListBeneFailure = (): FetchListBeneFailure => ({
  type: FETCH_LIST_BENE_FAILURE,
});

export const fetchAddBeneProfileRequest = (payload?: AddBeneProfile): FetchAddBeneProfileRequest => ({
  type: FETCH_ADD_BENE_PROFILE_REQUEST,
  payload,
});

export const fetchAddBeneProfileSuccess = (payload?: TRANSPROFILE): FetchAddBeneProfileSuccess => ({
  type: FETCH_ADD_BENE_PROFILE_SUCCESS,
  payload,
});

export const fetchAddBeneProfileFailure = (): FetchAddBeneProfileFailure => ({
  type: FETCH_ADD_BENE_PROFILE_FAILURE,
});

export const fetchAddBeneTemplateRequest = (payload?: TEMPLATE): FetchAddBeneTemplateRequest => ({
  type: FETCH_ADD_BENE_TEMPLATE_REQUEST,
  payload,
});

export const fetchAddBeneTemplateSuccess = (): FetchAddBeneTemplateSuccess => ({
  type: FETCH_ADD_BENE_TEMPLATE_SUCCESS,
});

export const fetchAddBeneTemplateFailure = (): FetchAddBeneTemplateFailure => ({
  type: FETCH_ADD_BENE_TEMPLATE_FAILURE,
});
